export class LmFormGenerator {
  constructor() {
    this.availableComponents = [
      {
        tag: 'q-input',
        title: 'Text Input',
        description: 'A short input field with space for entering a free-text word or a short sentence.',
        type: 'text',
        settings: {
          name: null,
          open: false,
          style: {},
          label: null,
          placeholder: null,
          value: null,
          required: false,
          helper: null,
          settingPlaceholders: {
            label: 'Your label (can be empty, but not' + ' recommended)',
            helper: 'Some helper text (modify in settings)',
            placeholder: 'Your placeholder (can be empty)'
          }
        }
      },
      {
        tag: 'q-input',
        type: 'textarea',
        title: 'Text Box',
        description: 'A bigger input field with space for entering one or few sentences.',
        settings: {
          name: null,
          open: false,
          style: {},
          label: null,
          placeholder: null,
          value: null,
          rows: '7',
          required: false,
          helper: null,
          settingPlaceholders: {
            label: 'Your label (can be empty, but not' + ' recommended)',
            helper: 'Some helper text (modify in settings)',
            placeholder: 'Your placeholder (can be empty)'
          }
        }
      },
      {
        tag: 'q-input',
        title: 'Number Input',
        description: 'An input field for a number which only supports numeric input.',
        type: 'number',
        settings: {
          name: null,
          open: false,
          style: {},
          label: null,
          placeholder: null,
          value: null,
          required: false,
          helper: null,
          settingPlaceholders: {
            label: 'Your label (can be empty, but not' + ' recommended)',
            helper: 'Some helper text (modify in settings)',
            placeholder: 'Your placeholder (can be empty)'
          }
        }
      },
      {
        tag: 'q-option-group',
        title: 'Radio Group',
        description: 'A group of options where only one option can be selected.',
        type: 'radio',
        settings: {
          name: null,
          open: false,
          style: {},
          label: null,
          value: null,
          options: [{ label: 'Option 1', value: 'Option 1' }],
          required: false,
          helper: null,
          settingPlaceholders: {
            label: 'Your label (can be empty, but not' + ' recommended)',
            helper: 'Some helper text (modify in settings)'
          }
        }
      },
      {
        tag: 'q-option-group',
        title: 'Checkbox Group',
        description: 'A group of options where many options can be selected.',
        type: 'checkbox',
        settings: {
          name: null,
          open: false,
          style: {},
          label: null,
          value: [],
          options: [{ label: 'Option 1', value: 'Option 1' }],
          required: false,
          helper: null,
          settingPlaceholders: {
            label: 'Your label (can be empty, but not' + ' recommended)',
            helper: 'Some helper text (modify in settings)'
          }
        }
      },
      {
        tag: 'q-select',
        title: 'Select',
        description: 'A dropdown with many options where one can be selected.',
        settings: {
          name: null,
          open: false,
          style: {},
          label: null,
          placeholder: null,
          value: null,
          options: [{ label: 'Option 1', value: 'Option 1' }],
          required: false,
          helper: null,
          settingPlaceholders: {
            label: 'Your label (can be empty, but not' + ' recommended)',
            helper: 'Some helper text (modify in settings)',
            placeholder: 'Your placeholder (can be empty)'
          }
        }
      },
      {
        tag: 'p',
        type: 'html',
        title: 'Custom text',
        description:
          'Appears as text in the form. Can be used as headings for form sections for example. It is not an input.',
        settings: {
          name: null,
          open: false,
          style: {
            fontSize: '1.1rem',
            margin: '0',
            fontWeight: 'bold',
            fontStyle: 'italic',
            textDecoration: 'underline',
            color: '#333'
          },
          value: null,
          required: false,
          settingPlaceholders: {
            placeholder: 'Use the edit button to create your custom text.'
          }
        }
      }
    ]
  }

  generateName() {
    return (
      '_' +
      Math.random()
        .toString(36)
        .substr(2, 9)
    )
  }
}
